import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import SheetTitle from '../../../components/SheetTitle';
import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import BackButton from '../../../components/BackButton';
import c from '../Help.less';

export default function HowToRegister() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/how-to-register" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="How to register/sign up" />
      <p>Welcome to Mp3Caprice!</p>
      <p>
        In order to sign up for our service, in the top right corner, please click on <Link to="/shop/signup">Sign Up</Link>.
        Please fill out the few fields and press <strong>SIGN UP</strong>. Registering with us is safe and <strong>free</strong>.
      </p>
      <p>
        From there on, you can browse your favorite music, add it to your cart in order to estimate how much balance
        you need to purchase your tracks.
      </p>
      <p>
        You can change your <strong>personal information</strong>, <strong>password</strong> and{' '}
        <strong>notification settings</strong> in the edit section.
      </p>
      <p>
        Please click on your username, in the top right corner of the page and then the <strong>edit icon</strong>.
        Please use the form to update your info and preferences, after that press <strong>Update</strong>.
      </p>

      <HelpContactUs subject={2} />
    </div>
  );
}
